import { useContext, useEffect, useState } from 'react'
import { AppContext } from 'contexts/AppContext'
import './Product.css'
import Headline6 from 'components/elements/Headline6'
import ContentSmall from 'components/elements/ContentSmall'
import IconButtonLarge from 'components/elements/IconButtonLarge'
import Heart2 from 'components/icons/Heart2'
import ButtonLarge1 from 'components/elements/ButtonLarge1'
import ContentNormal from 'components/elements/ContentNormal'
import Translate, { translate } from 'utils/Translate'
import Cart1 from 'components/icons/Cart1'
import { useNavigate, useParams } from 'react-router-dom'
import ButtonMedium4 from 'components/elements/ButtonMedium4'
import ButtonInactive from 'components/elements/ButtonInactive'
import _ from 'lodash'
import { callAPI } from "utils/API";
import { parseLinks, priceConvertor } from 'utils/general'
import { Box } from "@mui/material";
import { addProductToBasket, basketHasRoomforMoreProducts, isOrderLimitExhausted } from 'utils/basket'
import { callTagManagerEvent, setupBasketData } from 'utils/setup'
import { Modal } from "react-bootstrap"
import { TaxPercentageForm } from 'components/blocks/taxPercentageForm/TaxPercentageForm'
import { debounce } from 'utils/debouce'
import { setupProductImages } from 'utils/productImageHelper'
import ProductContainer from './ProductContainer'
import { orderErrorToTranslation } from 'modules/basket/Basket'

const Coupon = (props) => {
    const { checkBasketForOnePointUser, productInfo } = props
    const { styleGuide, accessibleShops, basket, userData, setBasket, brandData, langCode, setUserData } = useContext(AppContext)
    const { ProductID } = useParams()
    const navigate = useNavigate()

    const defaultCarouselInterval = 1000
    
    const [interval, setinterval] = useState(defaultCarouselInterval)
    const [productReactionLoading, setProductReactionLoading] = useState(false)
    const [viewMore, setViewMore] = useState(false)
    const [activeIndex, setactiveIndex] = useState(null)

    const [productDetails, setproductDetails] = useState({})
    const [ShopID, setShopID] = useState(accessibleShops && accessibleShops.length > 0 ? accessibleShops[0].ShopID : null)
    const [productVariations, setproductVariations] = useState([])

    const [selectedTitle, setselectedTitle] = useState(null)
    const [selectedSize, setselectedSize] = useState(null)
    const [selectedVariation, setselectedVariation] = useState(null)
    const [selectedVariationStock, setselectedVariationStock] = useState(null)
    const [selectedQuantity, setSelectedQuantity] = useState(1)

    const [activationLoading, setActivationLoading] = useState(false)
    const [userNote, setUserNote] = useState('')

    const [errorMessage, setErrorMessage] = useState(null)
    const [showError, setShowError] = useState(false)

    const summaryContentLength = 200
    const price = productDetails?.sellingPrice || {type: 'POINTS', amount: 0}
    const pointSuffix = translate("_POINTS_SHORT_", "pt")
    const dkkSuffix = translate("_DKK_", "kr")
    const taxProduct = userData?.taxPercentage ? Math.ceil(price.amount / (brandData.brandPointRatio || 1) * userData.taxPercentage / 100) : null
    const headerSpacing = 10

    const isUserAdmin = () => {
        if (userData?.userPrivilege == "MANAGE") {
            return true;
        } else {
            return false;
        }
    }

    const resetVariationDetails = () => {
        setinterval(defaultCarouselInterval)
        setactiveIndex(null)
        setselectedVariation(null)
        setselectedVariationStock(null)
        setselectedSize(null)
        setselectedTitle(null)
    }

    const assignVariations = async (product) => {
        if (!product || !product.variations || !product.variations.length) {
            setproductVariations([])
            return
        }
        product.variations.forEach(variation => {
            variation.ImageID = variation.images && variation.images.length ? variation.images.map(img => img.ImageID)[0] : null
        });
        setproductVariations(product.variations)
        let sizes = []
        let colors = []
        let titles = []
        product.variations.sort((a, b) => a.poolOrder - b.poolOrder).map(vr => {
            const available = !vr.limitedStock ? true : !vr.variationStock ? false : true
            const colorName = vr.colorName
            if (!sizes.filter(v => v.variant === vr.variationSize).length) !!vr.variationSize && sizes.push({ variant: vr.variationSize, available })
            if (!colors.filter(v => v.variant === vr.colorHexcode).length) !!vr.colorHexcode && colors.push({ variant: vr.colorHexcode, available, colorName: colorName })
            if (!titles.filter(v => v.variant === vr.variationTitle).length) !!vr.variationTitle && titles.push({ variant: vr.variationTitle, available })
        })
        if (product.variations.length === 1 || brandData?.features?.addTobasketWithoutCondition) {
            setselectedVariation(product.variations[0])
            if (brandData?.features?.addTobasketWithoutCondition) {
                if (sizes?.length) {
                    setselectedSize(sizes[0].variant)
                }
                if (titles?.length) {
                    setselectedTitle(titles[0].variant)
                }
            }
        }
        const productPrice = product.sellingPrice.amount
        callTagManagerEvent({
            dataLayer: {
                event: 'view_item',
                ecommerce: {
                    currency: 'DKK',
                    value: productPrice,
                    items: [{
                        item_name: product.elementTitle,
                        item_id: product.ProductID,
                        item_brand: product.manufacturer,
                        item_category: '',
                        item_variant: '',
                        quantity: 1,
                        price: productPrice
                    }]
                }
            },
        })

        return
    }

    const productReaction = async (product) => {
        setProductReactionLoading(true)
        const ReactionID = product.reaction ? product.reaction.ReactionID : null
        const reactionResponse = await callAPI("/product/reaction", "POST", { body: { ReactionTargetID: product.ProductID, reactionData: JSON.stringify({ ShopID: product.ShopID }), ...(ReactionID && { ReactionID }) } })
        await setupBasketData({userData, setBasket})
        if(reactionResponse !== false) {
            if(reactionResponse?.insertId === 0) {
                product.reaction = null
            } else if (reactionResponse?.insertId) {
                product.reaction = {
                    ReactionID: reactionResponse.insertId
                }
            }
        }
        setProductReactionLoading(false)
    }

    const activateCoupon = debounce(async () => {
        if (isOrderLimitExhausted(accessibleShops.find(s => s.ShopID === ShopID))) return
        if (!checkBasketForOnePointUser()) return

        if (!selectedVariation) return setErrorMessage(<Translate translationKey='VARIATION_NOT_SELECTED'>Du mangler at vælge variation. </Translate>)
        if (!selectedQuantity) return setErrorMessage(<Translate translationKey='QUANTITY_NOT_SELECTED'>Du mangler at vælge antal. </Translate>)
        if (selectedVariation.limitedStock === 1 && selectedVariation.variationStock < 1) return setErrorMessage(<Translate translationKey='VARIATION_NOT_IN_STOCK'>Produktet er ikke på lager længere.</Translate>)

        setActivationLoading(true)
        callTagManagerEvent({
            dataLayer: {
                event: 'activate_coupon',
                ecommerce: {
                    currency: 'DKK',
                    value: price.amount,
                    items: [{
                        item_name: productDetails.elementTitle,
                        item_id: productDetails.ProductID,
                        item_brand: productDetails.manufacturer || '',
                        item_category: productDetails.categories?.length ? productDetails.categories.map(c => c.categoryName).join() : '',
                        item_variant: selectedVariation.variationTitle,
                        quantity: selectedQuantity,
                        price: price.nonDiscountAmount
                    }]
                }
            },
        })

        setSelectedQuantity(1)
        setUserNote('')

        const basketInfo = await addProductToBasket(productDetails.ShopID, productDetails.ProductID, selectedVariation.VariationID, selectedQuantity, userNote)

        const request = { body: { baskets: basketInfo } } 
        const orderResponse = await callAPI("order/submit", "POST", request)
        if (
            !orderResponse ||
            !orderResponse.ConfirmationID ||
            isNaN(orderResponse.ConfirmationID) ||
            orderResponse.ConfirmationID <= 0
        ) {
            setErrorMessage(orderErrorToTranslation(orderResponse))
        } else {
            setUserData({
                ...userData,
                walletAmountPoints: userData.walletAmountPoints - productDetails.sellingPrice?.amount,
            })

            navigate('/profile/coupons')
        }
        
        setActivationLoading(false)

    }, 500)

    useEffect(() => {
        setShowError(!!errorMessage)
    }, [errorMessage])

    useEffect(() => {
        if (!selectedVariation) {
            setselectedVariationStock(null)
        } else {
            setselectedVariationStock(selectedVariation.limitedStock && selectedVariation.variationStock >= 0 ? selectedVariation.variationStock : null)
        }
    }, [selectedVariation]);

    useEffect(() => {
        if (!!productDetails && productDetails.ShopID) setShopID(productDetails.ShopID)
    }, [viewMore, productDetails]);

    useEffect(() => {
        resetVariationDetails()
    }, [ProductID, accessibleShops]);

    useEffect(() => {
        const variationByTitle = selectedTitle ? productVariations.filter(item => item.variationTitle === selectedTitle) : []
        const variationBySize = selectedSize ? productVariations.filter(item => item.variationSize === selectedSize) : []
        if (variationBySize.length === 1) {
            setselectedVariation({ ...variationBySize[0] })
        } else if (variationByTitle.length) {
            setselectedVariation({ ...variationByTitle[0] })
        } else {
            setselectedVariation(null)
        }
    }, [selectedSize, selectedTitle])

    useEffect(() => {
        if(productInfo?.length) {
            setupProductImages(productInfo[0], true)
            setproductDetails(productInfo[0])
            assignVariations(productInfo[0])
        }
    }, [productInfo])

    if (isNaN(ProductID) || !productDetails || !productDetails.ProductID) {
        return null
    }

    const productDescription = productDetails?.translations?.find((translation) => translation.languageKey === langCode)?.elementContent || productDetails.elementContent

    return <>
        <ProductContainer activeIndex={activeIndex} interval={interval} productDetails={productDetails} ShopID={ShopID} >
            <div style={{ marginBottom: 10 }}>
                {
                    !!selectedVariationStock
                        ? <ContentSmall skipTranslation={true} style={{ color: styleGuide.color6 }}>{selectedVariationStock} stk. på lager</ContentSmall>
                        : <>&nbsp;</>
                }
            </div>
            {!!productDetails.enableDiscount && !brandData?.features?.disableProductDiscountTag && <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 20, gap: 10 }}>
                <ContentNormal skipTranslation={true} style={{ color: styleGuide.color6, textDecoration: 'line-through' }}>{priceConvertor(brandData, productDetails.sellingPrice.nonDiscountAmount, price.type === 'POINTS' ? pointSuffix : dkkSuffix)}</ContentNormal>
                <ContentNormal skipTranslation={true} style={{ color: styleGuide.color25, }}>{`${translate('_PRODUCT_DISCOUNT_TAG_TEXT_', 'Spar')} ${Math.round(((productDetails.sellingPrice.nonDiscountAmount - productDetails.sellingPrice.amount) / productDetails.sellingPrice.nonDiscountAmount) * 100)}%`}</ContentNormal>
            </div>}
            {brandData?.features?.retailPrice &&
                productDetails?.retailPrice && (
                    <ContentNormal skipTranslation={true} style={{ color: styleGuide.color7, marginBottom: 20 }}>Vejl. udsalgspris: Kr. {productDetails.retailPrice} inkl. moms</ContentNormal>
                )
            }
            <div style={{ marginBottom: headerSpacing, display: 'flex', flexDirection: 'column' }}>
                <div style={{ display: 'flex', flexDirection: 'row', gap: 20 }}>
                    {!brandData?.features?.disableWishlist &&
                        <IconButtonLarge
                            inverse={productDetails.reaction && productDetails.reaction.ReactionID && productDetails.reaction.ReactionID > 0}
                            icon={<Heart2 fill='white' stroke={styleGuide.color7} strokeWidth="1.5px" />}
                            onClick={() => productReaction(productDetails)}
                            loading={productReactionLoading}
                        />
                    }
                    {basketHasRoomforMoreProducts(basket, accessibleShops.find(s => s.ShopID === ShopID)) && !isOrderLimitExhausted(accessibleShops.find(s => s.ShopID === ShopID))
                        ?
                            (brandData?.features?.onlyAdminOrderEnabled) && (!isUserAdmin())
                                ? <div></div>
                                : <ButtonLarge1
                                    title={!!brandData?.features?.disablePrice ? null : translate("_COUPON_ACTIVATE_", "Aktivér")}
                                    onClick={activateCoupon}
                                    loading={activationLoading}
                                    disabled={(brandData?.features?.disableAddtoCartShopIDs?.length && brandData.features.disableAddtoCartShopIDs.includes(ShopID))}
                                    icon={!!brandData?.features?.disablePrice ? null : <Cart1 fill={styleGuide.color1} style={{ marginLeft: '64px' }} />}
                                    fallbackText={!!brandData?.features?.disablePrice ? brandData?.features?.productButtonText[langCode] : !brandData?.features?.disablePoints
                                        ? priceConvertor(brandData, `${price.amount}`, price.type === 'POINTS' ? pointSuffix : dkkSuffix)
                                        : translate("_COUPON_ACTIVATE_", "Aktivér")
                                    }
                                />
                        :
                            <ButtonInactive
                                buttonText='Du kan ikke vælge flere'
                                style={{ height: '45px', width: '80%' }}
                                disabled={true}
                            />
                    }
                </div>
                {!!taxProduct && <div style={{ marginRight: 8, marginLeft: !!brandData?.features?.disableWishlist ? 0 : 64, marginBottom: 16 }}>
                    <ContentSmall style={{ paddingLeft: 4, paddingRight: 4, fontStyle: 'italic' }} fallbackText={`${translate('_PRODUCT_TAXATION_TEXT_', 'Beskatning kr.')} ${priceConvertor(brandData, taxProduct, '')}`} />
                </div>}
            </div>
            {
                !userData?.taxPercentage && <TaxPercentageForm />
            }
            <div style={{ marginBottom: 40 }} />
            <Headline6 style={{ color: styleGuide.color7 }}>
                {translate('_PRODUCT_DESCRIPTION_TAB_CAPTION_', 'Beskrivelse')}
            </Headline6>
            <Box style={{ display: 'flex', flexDirection: 'column', marginTop: headerSpacing }}>
                <ContentSmall
                    skipTranslation={true}
                >{viewMore ? parseLinks(productDescription) : parseLinks(_.truncate(productDescription, { length: summaryContentLength }))}</ContentSmall>
                {
                    !!productDescription && productDescription.length > summaryContentLength &&
                    <div>
                        <ButtonMedium4
                            style={{ marginTop: 20 }}
                            fallbackText={viewMore ? translate('_READ_LESS_BUTTON_TEXT_', 'Læs mindre') : translate('_READ_MORE_BUTTON_TEXT_', 'Læs mere')}
                            showIcon={false}
                            onClick={() => setViewMore(!viewMore)}
                        />
                    </div>
                }
            </Box>
        </ProductContainer>

        <Modal show={showError} onHide={() => setShowError(false)} style={{ margin: 'auto' }} centered>
            <Modal.Header className="pb-0 border-0" closeButton style={{ fontSize: 9 }}>
                <Headline6 style={{ color: styleGuide.color13 }} translationKey="_ERROR_">Fejl</Headline6>
            </Modal.Header>
            <Modal.Body className="pt-4 pb-4">
                <p style={{ textAlign: 'center' }}>{errorMessage}</p>
            </Modal.Body>
        </Modal>
    </>
}

export default Coupon
